import { InvestorDetailsPacingTabCommitmentPlansQuery } from '@/__generated__/graphql';
import DropdownActions from '@/components/table/dropdownActions';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { IItems } from '@/components/table/types';
import { getUTCDate } from '@/shared/utils/date';
import { useNavigate, useParams } from 'react-router-dom';
import { columns } from '../../constants';

interface AllCommitmentPlansMobileTableProps {
  tableRows: InvestorDetailsPacingTabCommitmentPlansQuery['commitmentPlans']['data'];
  updateLoading: boolean;
  currentRow: InvestorDetailsPacingTabCommitmentPlansQuery['commitmentPlans']['data'][number] | null;
  dropdownActions: (row: InvestorDetailsPacingTabCommitmentPlansQuery['commitmentPlans']['data'][number]) => IItems[];
}

const AllCommitmentPlansMobileTable = ({ tableRows, updateLoading, currentRow, dropdownActions }: AllCommitmentPlansMobileTableProps) => {
  const params = useParams();
  const navigate = useNavigate();

  const investorId = params?.investorId || '';
  const entityId = params?.entityId || '';

  const TableRow = ({ el }: { el: InvestorDetailsPacingTabCommitmentPlansQuery['commitmentPlans']['data'][number] }) => {
    return (
      <MobileTableRowWrap key={el.id} loading={updateLoading && el.id === currentRow?.id ? 1 : 0}>
        <MobileRow>
          <MobileRowTitle>{columns[0].title}</MobileRowTitle>
          <MobileRowValue
            onClick={() =>
              navigate(`/investors/${investorId}/${entityId}?backToTitle=All Commitment Plans&activeTab=Pacing&commitmentPlanId=${el.id}`)
            }
            isRedirect
          >
            {el.name}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[1].title}</MobileRowTitle>
          <MobileRowValue>{getUTCDate(new Date(el.startDate))}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[2].title}</MobileRowTitle>
          <MobileRowValue>{el?.growthRate && `${el.growthRate.toFixed(2)}%`}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowValue>
            <DropdownActions isMobile isListCenter items={dropdownActions(el)} disabled={updateLoading && el.id === currentRow?.id} />
          </MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {tableRows.length ? (
        <>
          {tableRows.map((el) => {
            return <TableRow el={el} key={el.id} />;
          })}
        </>
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default AllCommitmentPlansMobileTable;
